module.exports = __webpack_public_path__ + "img/stvrt-block-1.0dc17f8b.jpg";